import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export const AuthRoute = ({ children }) => {
  const { isLoggedIn } = useSelector((store) => store.auth);
  if (!isLoggedIn) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};

export const AppRoute = ({ children }) => {
  const { isLoggedIn } = useSelector((store) => store.auth);
  if (isLoggedIn) {
    // user is authenticated
    return <Navigate to="/" />;
  }
  return children;
};

export const OnBoardRouteGuard = ({ children }) => {
  const { user } = useSelector((store) => store.auth);
  if(!user) {
    return null;
  }
  if (user.resetPassword) {
    // user is authenticated
    return <Navigate to="/createNewPassword" />;
  }
  if(!user.detailsAdded && user?.type !== 'trader') {
    return <Navigate to="/updateCompanyProfile" />;
  }
  return children;
};

export const CreatePasswordRouteGuard = ({ children }) => {
  const { user } = useSelector((store) => store.auth);
  if(!user) {
    return null;
  }
  if (!user.resetPassword) {
    // user is authenticated
    return <Navigate to="/" />;
  }
  return children;
};

export const UpdateCompanyRouteGuard = ({ children }) => {
  const { user } = useSelector((store) => store.auth);
  if(!user) {
    return null;
  }
  if (user.detailsAdded) {
    // user is authenticated
    return <Navigate to="/" />;
  }
  return children;
};


//dashboard sidemenu permission based Protected Routes
export const PermissionRoute = ({ children, name }) => {
  
  // const { sideMenuList } = useSelector((store) => store.auth);
  // let find = sideMenuList.find((item) => item.name === name)

  // if (!find?.flag) {
  //     return <Navigate to="/login" />;
  // }
  return children;
};
export const PermissionDashboardRoute = ({ children, name }) => {
  const { user } = useSelector((store) => store.auth);
  if(user.type === 'trader') {
    if(user?.clientCount > 0) {
      return <Navigate to="/tradeManagement" />;
    }
  }
  // const { sideMenuList } = useSelector((store) => store.auth);
  // let find = sideMenuList.find((item) => item.name === name)

  // if (!find?.flag) {
  //     return <Navigate to="/login" />;
  // }
  return children;
};
